module.exports = __webpack_public_path__ + "static/media/icon.f42b4363.png";